module.exports = __webpack_public_path__ + "static/media/logoindex.5284129d.png";